module.exports = __webpack_public_path__ + "static/media/harina_alpesa.91a7fcb0.png";